import appConfig from 'app-config';

export default class MLQuotePaymentIDsService {
    static getAvailablePaymentPlanIDs(submission) {
        const { MLRatingForMonthlyPayment, MLRatingForAnnualPayment, MLRatingForMortgageePayment, MLRatingForCheckPayment } = appConfig.mlRatingConfigs;
        let availablePaymentPlanIDs;
        if (submission.isDwelling() || submission.isCondo() || submission.isLandlordHome() || submission.isLandlordCondo()) {
            availablePaymentPlanIDs = [MLRatingForMonthlyPayment, MLRatingForAnnualPayment, MLRatingForMortgageePayment];
        } else {
            availablePaymentPlanIDs = [MLRatingForMonthlyPayment, MLRatingForAnnualPayment];
        }

        if (submission.baseData.policyAddress.state === 'NJ') {
            availablePaymentPlanIDs.push(MLRatingForCheckPayment);
        }

        return availablePaymentPlanIDs;
    }
}